// DSS Documentation on SocoWebAuthService - http://tiny.sc/socowebauthservice
import { Injectable } from '@angular/core';

@Injectable()
export class SocoWebAuthService {
    redirectToLoginPage(): void {
        window.location.reload();
    }
}
